import { useState } from "react";
import type { ReactElement } from "react";
import type { Unternehmen } from "@kundeninfo/api-client";
import { KiKnopf } from "../components/meHuellen.js";
import { useObjektPanel } from "../components/objektPanel/ObjektPanelKontext.js";
import { TicketListe } from "./tickets/TicketListe.js";
import { TicketAnlegen } from "./tickets/TicketAnlegen.js";
import type { TicketsClient } from "./tickets/ticketsClient.js";
import "./tickets/TicketAnlegen.css";

/** AKTE-REITER „TICKETS" (F33): die Liste auf diesen Kunden gefiltert (gleiche Ordnung,
 *  „Archiv einbeziehen"), „+ Aufgabe" mit vorbelegtem Kunden. Wählbar sind nur die aktiven
 *  Unternehmen, denen der Kunde zugeordnet ist (F42) — bei mehreren fragt der Dialog, Vorgabe
 *  das Arbeitsunternehmen. Ein Ticket — auch das eben angelegte — öffnet als Objektpanel über der Akte (Öffnen statt
 *  Springen A9); hat es geschrieben, lädt die Liste im Stehen nach (F9). */
export function KundeTickets(p: {
  client: TicketsClient; companies: readonly Unternehmen[];
  kunde: { id: string; companyName: string; relations: readonly { shortCode: string }[] };
  arbeitsunternehmenId: string | null; ich: { id: string; name: string };
}): ReactElement {
  const [anlegen, setAnlegen] = useState(false);
  const [neuLaden, setNeuLaden] = useState(0);
  const panels = useObjektPanel();
  const oeffne = (id: string): void => panels.oeffne({ art: "ticket", id }, { onGeaendert: () => setNeuLaden((n) => n + 1) });
  return (
    <div className="kt">
      <KiKnopf art="primaer" onClick={() => setAnlegen(true)}>+ Aufgabe</KiKnopf>
      <TicketListe client={p.client} companies={p.companies} kundeId={p.kunde.id} ichId={p.ich.id}
        onOeffnen={oeffne} neuLaden={neuLaden} />
      {anlegen && (
        <TicketAnlegen client={p.client} companies={p.companies} ich={p.ich} vorgabeCompanyId={null}
          arbeitsunternehmenId={p.arbeitsunternehmenId}
          kunde={{ id: p.kunde.id, name: p.kunde.companyName, kuerzel: p.kunde.relations.map((r) => r.shortCode) }}
          onAbbrechen={() => setAnlegen(false)}
          onAngelegt={(id) => { setAnlegen(false); setNeuLaden((n) => n + 1); oeffne(id); }} />
      )}
    </div>
  );
}
